import { Navigate } from "react-router-dom";
import { useUser } from "../context/userContext";

// Keeps onboarding available only to authenticated users who have not
// completed it yet. Subscription creation happens as part of the final
// onboarding action, so subscription state no longer controls this route.
export default function OnboardingFlowRoute({ children }) {
  const { isAuthenticated, loading, isOnboarded, holdOnboardingRedirect } = useUser();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // While true, OnboardingPage is mid claim-credit animation and will
  // navigate itself once it's done — don't yank the page out from under it.
  if (isOnboarded && !holdOnboardingRedirect) return <Navigate to="/transcribe" replace />;
  return children;
}
